import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProgressCircleComponent } from '../../../shared/progress-circle/progress-circle.component';
import { RouterLink } from '@angular/router';
import { NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbAccordionCollapse, NgbAccordionBody } from '@ng-bootstrap/ng-bootstrap/accordion';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap/progressbar';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap/collapse';

@Component({
    selector: 'app-dashboard-subject-ux',
    templateUrl: './dashboard-subject-ux.component.html',
    styleUrls: ['./dashboard-subject-ux.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ProgressCircleComponent, RouterLink, NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbProgressbar, NgbCollapse, NgbAccordionCollapse, NgbAccordionBody]
})
export class DashboardSubjectUxComponent implements OnInit {

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  open(content) {
    this.modalService.open(content, { size: 'lg' });
  }

}
